<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <h2>Iniciar Sesión</h2>
                </div>

                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/">Inicio </a></li>
                        
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="user-area-all-style log-in-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="contact-form-action">
                    <div class="form-heading text-center">
                        <h3 class="form-title-no-transform">Bienvenido a enCloud!</h3>
                        <p class="form-desc">Conectamos tus ideas con el poder y la eficiencia de la nube.</p>
                    </div>

                    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                        <div class="row">
                          <!-- Campo Email -->
                          <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                              <input formControlName="email" class="form-control" type="email" placeholder="Correo Electrónico">
                              <div *ngIf="f.email.touched" class="error-message">
                                <small class="text-danger" *ngIf="f.email.errors.required">El correo electrónico es obligatorio.</small>
                                <small class="text-danger" *ngIf="f.email.errors.email">Debe ser un correo electrónico válido.</small>
                              </div>
                            </div>
                          </div>
                      
                          <!-- Campo Contraseña -->
                          <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                              <input formControlName="password" class="form-control" type="password" placeholder="Contraseña">
                              <div *ngIf="f.password.touched" class="error-message">
                                <small class="text-danger" *ngIf="f.password.errors.required">La contraseña es obligatoria.</small>
                                <small class="text-danger" *ngIf="f.password.errors.minlength">Debe tener al menos 12 caracteres.</small>
                              </div>
                            </div>
                          </div>
                      
                          <!-- Botón Recordar y Olvidé mi contraseña -->
                          <div class="col-lg-6 col-md-6 form-condition">
                            <div class="agree-label">
                              <input type="checkbox" id="chb1">
                              <label for="chb1">Recordarme</label>
                            </div>
                          </div>
                      
                          <div class="col-lg-6 col-md-6">
                            <!-- <a class="forget" routerLink="/recover-password">¿Olvidé mi contraseña?</a> -->
                            <a class="forget" >¿Olvidaste tu contraseña?</a>

                          </div>
                      
                          <!-- Botón de Envío -->
                          <div class="col-lg-12 col-md-12">
                            <button [disabled]="loginForm.invalid" class="default-btn btn-two" type="submit">Iniciar sesión</button>
                          </div>
                      
                          <!-- Registro -->
                          <!-- <div class="col-lg-12 col-md-12">
                            <p class="account-desc">¿No eres miembro? <a routerLink="/sign-up">Regístrate</a></p>
                          </div> -->
                        </div>
                      </form>
                      
                      
                      
                      
                </div>
            </div>
        </div>
    </div>
</section>